import {
  MedicationListFilters,
  MedicationListItem,
} from "../data-model/medicationListModel";

/** Quick stable hash of the fields a user can edit on a row, for dirty-tracking. */
export const rowSignature = (m: MedicationListItem): string => {
  return JSON.stringify({
    class: m.class || "",
    cohort: m.cohort || "",
    related_drugs: [...(m.related_drugs || [])],
    name_collision_exclusions: [...(m.name_collision_exclusions || [])],
    name_replacement: m.name_replacement || "",
    replacement_name: m.replacement_name || "",
  });
};

/** Case-insensitive match on display_name, name, and any related drug. */
export const matchesSearch = (
  m: MedicationListItem,
  query: string,
): boolean => {
  if (!query.trim()) return true;
  const q = query.trim().toLowerCase();
  if ((m.display_name || "").toLowerCase().includes(q)) return true;
  if ((m.name || "").toLowerCase().includes(q)) return true;
  return (m.related_drugs || []).some((d) => d.toLowerCase().includes(q));
};

export const matchesFilters = (
  m: MedicationListItem,
  filters: MedicationListFilters,
): boolean => {
  if (filters.classes.length && !filters.classes.includes(m.class as any))
    return false;
  if (filters.cohorts.length && !filters.cohorts.includes(m.cohort as any))
    return false;
  if (filters.sources.length && !filters.sources.includes(m.source as any))
    return false;
  return true;
};

export const sortByDisplayName = (
  a: MedicationListItem,
  b: MedicationListItem,
) => (a.display_name || "").localeCompare(b.display_name || "");

/** Add a tag to a list, case-insensitive dedupe. Returns same array if duplicate. */
export const addTag = (list: string[], tag: string): string[] => {
  const trimmed = tag.trim();
  if (!trimmed) return list;
  const exists = list.some((t) => t.toLowerCase() === trimmed.toLowerCase());
  return exists ? list : [...list, trimmed];
};

export const removeTag = (list: string[], tag: string): string[] =>
  list.filter((t) => t !== tag);

export const activeFilterCount = (filters: MedicationListFilters): number =>
  filters.classes.length + filters.cohorts.length + filters.sources.length;
